<template>
	<div class="bg-white all margin-left padding-lr flex-sub">
		<el-form :label-position="labelPosition" label-width="80px" :model="userinfo" :rules="rules"
			ref="formLabelAlign" class="padding-tb">
			
			<el-form-item label="新密码" prop="experience">
				<div class="padding-lr-sm">
					<el-input type="number" v-model.number="userinfo.pass" autocomplete="off" placeholder="请编辑新密码">
					</el-input>
				</div>
			</el-form-item>
			
			<el-form-item label="确认密码" prop="salary">
				<div class="padding-lr-sm">
					<el-input type="number" v-model.number="userinfo.passtwo" autocomplete="off" placeholder="请确认新密码">
					</el-input>
				</div>
			</el-form-item>
			<el-button type="primary" @click="submitForm()">确认</el-button>
			
		</el-form>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				labelPosition: 'left',
				userinfo:{
					pass: '', //新密码
					passtwo:'',//确认密码
					
				},
				rules: {
					pass: [{
						required: true,
						message: '请编辑新密码',
						trigger: 'change'
					}],
					passtwo:[{
						required: true,
						message: '请确认新密码',
						trigger: 'change'
					}],
					
				}, //表单校验规则
			}
		},
		computed: {
			userInfo() {
				if (this.$store.getters.userInfo) {
					return this.$store.getters.userInfo;
				} else {
					return JSON.parse(localStorage.getItem('USER_INFO'));
				}
			}
		},
		methods:{
			//立即创建
			submitForm() {
				this.$refs.formLabelAlign.validate((valid) => {
					if (valid) {
						this.subedit()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			showKeyBoard(){
				
			},
			subedit(){
				
				const that = this
				
				// 验证信息 end
				this.ajax('post', '/api/pc/user/setPwd', {
					password:this.userinfo.pass,
					password_true:this.userinfo.passtwo,
				}, res => {
					if (res.status == 200) {
						this.$message("成功")
					} else {
						
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.all{
		padding-top: 50px;
	}
	.mobel{
		font-size: 25px;
	}
	.main-center {
	  height: 80px;
	  width: 100%;
	  
	}
	.code {
	  height: 80px;
	  margin-top: 32px;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  
	}
	.code-box {
	  display: flex;
	  flex-direction: row;
	  justify-content: center;
	  align-items: center;
	  
	}
	.text-blue2{
	  color: #3B9DFF;
	}
		
	.code-box-item {
	  // width: 60px;
	  height: 60px;
	  background: #fff;
	  font-size: 30px;
	  line-height: 60px;
	  text-align: center;
	  border: 1px solid #d0d0d0;
	}
	.radius-20{
		border-radius: 20px;
	}
	// 下一步按钮 start
	.btn_cloce {
	  margin-top: 32px;
	  width: 100%;
	  text-align: center;
	  .types {
		  width: 383px;
		  height: 60px;
		  background: #09827B;
		  box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		  border-radius: 30px;
		  margin: 0 auto;
		  
	    
	    color: #ffffff;
	    line-height: 60px;

	    
	  }
	}
	// 下一步按钮 end
</style>



// WEBPACK FOOTER //
// src/components/my/password/setpas.vue